import { useImportTagPrinterScripts } from "./useImportTagPrinterScripts";

export default useImportTagPrinterScripts;
